export const clickCheckboxWithId = (id: string, targetState: string) => {
  const targetElement = document.getElementById(id)
  if (targetElement && targetElement.getAttribute('data-state') !== targetState) {
    targetElement.click()
  }
}

export const openFile = async (url: string, contentType?: string) => {
  if (
    !contentType ||
    contentType.includes('html') ||
    contentType.includes('pdf') ||
    contentType.includes('xml') ||
    contentType.includes('svg')
  ) {
    try {
      const downloadUrl = url.replace('inline=true', '')
      const response = await fetch(downloadUrl)
      const blob = await response.blob()
      const objectUrl = window.URL.createObjectURL(blob)
      const link = document.createElement('a')
      link.href = objectUrl

      const contentDisposition = response.headers.get('content-disposition')
      let filename = ''
      if (contentDisposition) {
        const matches = /filename\*=UTF-8''([^;]+)/i.exec(contentDisposition)
        if (matches?.[1]) {
          filename = decodeURIComponent(matches[1])
        } else {
          const filenameMatches = /filename="?([^";\n]+)"?/i.exec(contentDisposition)
          if (filenameMatches?.[1]) {
            filename = filenameMatches[1]
          }
        }
      }

      link.download = filename || 'download'
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
      window.URL.revokeObjectURL(objectUrl)
    } catch (error) {
      console.error('Download failed:', error)
    }
    return
  }

  window.open(url, '_blank', 'noopener,noreferrer')
}
